<template>
  <div class="content md no-padding flex-box vertical">
    <AreaForm ref="addForm" :initial="initial" class="add-form-box"></AreaForm>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleConfirm">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import AreaForm from "./components/AreaForm.vue";
import light from "../../common/mixins/light";

export default {
  name: "NicheAreaAdd",
  mixins: [light],
  components: {
    AreaForm,
  },
  data() {
    return {
      initial: null,
    };
  },
  methods: {
    handleCancel() {
      this.$router.back();
    },
    handleConfirm() {
      this.$refs.addForm.validate().then((form) => {
        this.$axios({
          url: `/admin/${this.apiPrefix}-worship-area`,
          method: "POST",
          data: form,
          noTempleFilter: true,
        }).then(() => {
          this.$message.success("添加成功");
          this.$router.back();
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
}
</style>
